"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreedGroup = exports.BreedSize = void 0;
var BreedSize;
(function (BreedSize) {
    BreedSize["TOY"] = "TOY";
    BreedSize["SMALL"] = "SMALL";
    BreedSize["MEDIUM"] = "MEDIUM";
    BreedSize["LARGE"] = "LARGE";
    BreedSize["GIANT"] = "GIANT";
})(BreedSize = exports.BreedSize || (exports.BreedSize = {}));
var BreedGroup;
(function (BreedGroup) {
    BreedGroup["COMPANION_DOGS"] = "COMPANION_DOGS";
    BreedGroup["HERDING_DOGS"] = "HERDING_DOGS";
    BreedGroup["HOUND_DOGS"] = "HOUND_DOGS";
    BreedGroup["HYBRID_DOGS"] = "HYBRID_DOGS";
    BreedGroup["MIXED_BREED_DOGS"] = "MIXED_BREED_DOGS";
    BreedGroup["SPORTING_DOGS"] = "SPORTING_DOGS";
    BreedGroup["TERRIER_DOGS"] = "TERRIER_DOGS";
    BreedGroup["WORKING_DOGS"] = "WORKING_DOGS";
})(BreedGroup = exports.BreedGroup || (exports.BreedGroup = {}));
